
<template>
<luma-account-details></luma-account-details>
</template>
<script>
    import LumaAccountDetails from "./details_account/luma-account-details";

    export default {
        name: "account-details",
        components: {LumaAccountDetails}
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/account-details.vue